{
    "meta": {
        "home": {
            "title": "Cancellation & Returns | baum-bmwshop24.de",
            "description": "Here you can easily submit your cancellation or return online. Please enter your order number and email address to get started."
        }
    },
    "global": {
        "support": "Support",
        "content_loading": "Loading content...",
        "order_loading": "Loading order...",
        "order_cancelation_in_progress": "Canceling order...",
        "searching": "Searching...",
        "oneMoment": "One moment please...",
        "form_is_submitting": "Submitting data...",
        "please_wait_while_we_process": "Large amounts of data may take some time to process. Please be patient while we handle your request.",
        "error": "An error has occurred.",
        "from": "from",
        "startFrom": "from",
        "to": "to",
        "notice": "Notice",
        "optional": "Optional",
        "optionalSquared": " (optional)",
        "privacy_policy": "Privacy policy",
        "amount": "Quantity",
        "starts": "from ",
        "sku": "Part number",
        "welcome_to": "Welcome to baum-bmwshop24.de",
        "choose_option": "Please choose an option"
    },
    "countrySwitcher": {
        "title": "Change language",
        "description": "Please select your language."
    },
    "buttons": {
        "yes": "Yes",
        "yes_change": "Yes, change",
        "no": "No",
        "understood": "Understood",
        "close": "Close",
        "choose": "Choose",
        "change": "Change",
        "change_country": "Change country",
        "contactform": "Contact form",
        "next": "Next",
        "back": "Back",
        "reset": "Reset",
        "apply": "Apply",
        "find": "Find",
        "save": "Save",
        "remove": "Remove",
        "submit": "Submit",
        "refresh": "Refresh",
        "cancel": "Cancel",
        "edit": "Edit",
        "cancelOrder": "Cancel order",
        "to_homepage": "to homepage",
        "to_website": "to website",
        "back_to_shop": "Back to shop",
        "to_article": "View item",
        "contact_support": "Contact support",
        "findOrder": "Find order",
        "return_portal": "To the returns portal",
        "submit_rma": "Complete warranty claim"
    },
    "form": {
        "pickup_file": "Upload file",
        "_": "{{$0}}",
        "email": "Email",
        "password": "Password",
        "password_repeat": "Repeat password",
        "firstname": "First name",
        "lastname": "Last name",
        "name": "Name",
        "required_bold": " **(Required)**",
        "phone": "Phone",
        "message": "Message",
        "streetAndNumber": "Street & house number",
        "street": "Street",
        "street_number": "No.",
        "appartment": "Address line 2 (e.g. apartment, floor)",
        "zipcode": "ZIP code",
        "city": "City",
        "country": "Country",
        "company": "Company",
        "vin": "Vehicle identification number",
        "sku": "Part number",
        "order_id": "Order or purchase number",
        "order_id_or_shop_order_id": "Purchase order number or shop order number",
        "order_id_description": "The purchase order number, starting with the current year (e.g. **2026**76...), can be found in your order confirmation or on your invoice. **It is not the shop order number (#BB24xxxx)**",
        "qty": "Quantity",
        "common_data": "Additional information",
        "common_data_for_spareparts": "Additional information for spare parts",
        "current_km": "Current mileage",
        "km_of_installation": "Mileage at installation",
        "workshop_invoice": "Attach workshop invoice",
        "vin_document": "Attach vehicle registration document (front & back)",
        "privacy": {
            "label": "Accept privacy policy",
            "description": "I have read and accept the privacy policy."
        },
        "errors": {
            "name": "Please enter your name.",
            "firstname": "Please enter your first name.",
            "company": "Please enter your company name.",
            "lastname": "Please enter your last name.",
            "email": "Please enter a valid email address.",
            "message": "Please enter a message.",
            "phone": "Please enter a valid phone number.",
            "order_id": "Please enter a valid purchase order number. You can find it in your order confirmation or on your invoice, and it starts with the current year (e.g. 2026). It is **not** the shop order number (#BB24xxxx).",
            "vin": "Please enter a valid vehicle identification number.",
            "sku": "Please enter a valid 11-digit part number.",
            "zipcode": "Please enter a valid ZIP code.",
            "streetAndNumber": "Please enter street and house number.",
            "termsAccepted": "Please accept the terms and conditions, cancellation policy, and privacy policy.",
            "city": "Please enter a city.",
            "country": "Please select a country.",
            "consent": "Please provide your consent for data processing.",
            "subject": "Please enter a subject.",
            "vat_id": "Please enter a valid VAT ID including country code (DEXXXXXXXXXX).",
            "vat_id_invalid": "The VAT ID provided is invalid.",
            "vat_id_invalid_country": "The VAT ID provided does not match the selected country.",
            "privacy": "Please accept the privacy policy.",
            "captcha": "Please confirm that you are not a robot.",
            "captcha_mismatch": "The captcha confirmation is incorrect.",
            "password_length": "The password must be at least 8 characters long.",
            "password_strength": "The password must be at least 8 characters long and contain uppercase letters, lowercase letters, numbers, and special characters.",
            "password_confirmation": "Please confirm your password.",
            "password_confirmation_mismatch": "The passwords do not match.",
            "password_invalid": "The password does not meet the minimum requirements.",
            "max_file_size": "The file exceeds the maximum size of 5MB.",
            "image_upload_failed": "Image upload failed. Please try again later or contact our support for further assistance."
        }
    },
    "messages": {
        "error": {
            "title": "An error has occurred.",
            "description": "Please try again later.",
            "longtitle": "An error has occurred. Please try again later or contact support."
        },
        "review": {
            "title": "Check input",
            "description": "Please review your entries and try again."
        },
        "order_not_found": {
            "title": "No order found.",
            "description": "No order could be found using the purchase order number and email address provided. If you have only just placed your order, **please wait up to 15 minutes** for our system to process it. If it still does not work, please contact our support for further assistance."
        },
        "not_stopable": {
            "title": "Order already in the shipping process",
            "description": "Unfortunately, we can no longer stop the shipment of your order because it has already reached or left our shipping center. However, you can return the order via our returns portal. If it is being shipped with DHL within Germany, you can also initiate a parcel stop via the tracking link."
        },
        "return_period_expired": {
            "title": "Cancellation period expired",
            "description": "Unfortunately, the cancellation period for your order has already expired. This period is 14 days from receipt of the goods. If you have any further questions or need assistance, please contact our support."
        },
        "image_upload_permission_denied": {
            "title": "Access denied",
            "description": "Permission to access the media library is required to upload images."
        },
        "rma_period_expired": {
            "title": "Warranty period expired",
            "description": "Unfortunately, the warranty period for the items you selected has already expired. Please check the purchase date and warranty conditions for your items. If you have any questions or need assistance, please contact our support."
        }
    },
    "language": {
        "de": {
            "iso": "DE",
            "name": "German"
        }
    },
    "support": {
        "title": "Support",
        "description": "Contact us if you need help.",
        "productHelp": "Questions",
        "instructions": {
            "title": "Guides & Documents",
            "description": "Here you will find helpful guides related to BMW & MINI.",
            "items": {
                "bmw_wheel_insurance": {
                    "title": "BMW Tire Insurance",
                    "description": "Learn more about BMW tire insurance and how to protect your tires in the best possible way."
                },
                "which_bmw_navi": {
                    "title": "Which BMW navigation system is right for me?",
                    "description": "Find out which BMW navigation system best suits your needs and your BMW."
                },
                "how_to_download_bmw_navi": {
                    "title": "How do I download the BMW Navigation Update?",
                    "description": "Learn step by step how to download the latest updates for your BMW navigation system."
                },
                "how_to_install_bmw_navi": {
                    "title": "How do I install the BMW Navigation Update?",
                    "description": "Learn how to install the updates on your BMW navigation system."
                }
            }
        },
        "mail": {
            "title": "info@baum-bmwshop24.de",
            "description": "Send us an email and we will get back to you as soon as possible."
        },
        "contactform": {
            "title": "Contact form",
            "description": "Simply send us an email via our contact form."
        },
        "phone": {
            "title": "0 2641 - 30 81 020¹",
            "description": "You are also welcome to contact us by phone. Our business hours: Mon-Thu: 9:00 AM - 5:00 PM, Fri: 9:00 AM - 4:00 PM"
        },
        "retoure": {
            "title": "Returns",
            "description": "Register returns and send-backs here."
        },
        "appointment": {
            "title": "Workshop appointment",
            "description": "Schedule a workshop visit at our branch in Bad Neuenahr-Ahrweiler today."
        },
        "faq": {
            "title": "FAQ",
            "description": "In our FAQ you will find answers to frequently asked questions about BMW, MINI, and our shop."
        },
        "lexikon": {
            "title": "BMW Glossary",
            "description": "In our BMW glossary you will find expert knowledge about the diverse BMW and MINI universe."
        },
        "blog": {
            "title": "Blog",
            "description": "Our blog features news from the world of BMW and MINI as well as useful information about automotive driving culture."
        }
    },
    "footer": {
        "legalLinks": {
            "imprint": "Legal notice",
            "privacy": "Privacy policy",
            "revocation": "Cancellation policy",
            "batteryRecycling": "Battery Act",
            "terms": "Terms and conditions",
            "accessibility": "Accessibility statement"
        }
    },
    "revocation": {
        "steps": {
            "start": "Start",
            "notice": "Notice",
            "find_order": "Find order",
            "product_list": "Select items",
            "cancel_order": "Cancel order",
            "success": "Successfully submitted",
            "submit_rma": "Complete warranty claim",
            "success_page": "Completion"
        }
    },
    "entry": {
        "createRevocation": "Cancel order",
        "createRma": "Submit warranty claim",
        "submit_revocation": {
            "title": "Cancel order",
            "description": "For orders you have just placed and that **have not yet left our warehouse.**"
        },
        "submit_return": {
            "title": "Request a return",
            "description": "For orders that have already **left our warehouse.**"
        },
        "submit_rma": {
            "title": "Submit warranty claim / complaint",
            "description": "Item defective or damaged **within the warranty period**?"
        }
    },
    "notice": {
        "infoText": "If you have only just placed your order, it may take **up to 15 minutes** for your order to appear in our system. For technical reasons, cancellation is unfortunately not possible before that. In this case, please try again in a few minutes or contact our support for further assistance.",
        "infoText2": "**ADVANCE PAYMENT order**: Orders paid by bank transfer do not need to be canceled, as they are automatically canceled if payment is not received within 7 days. You can simply choose not to pay and the order will be canceled automatically."
    },
    "productList": {
        "title": "Select items",
        "description": "Please select the items from your order that you would like to complain about. You can also specify the quantity if you only want to return part of the ordered items."
    },
    "rma": {
        "order_id_not_found": "Purchase order number could not be found, please try again.",
        "reason_of_return": "Reason for complaint",
        "selected_min_one_product": "Please select at least one item.",
        "fill_reason_of_return": "Please enter a reason for the complaint.",
        "add_pictures": "Add pictures",
        "add_more_pictures": "Add more pictures",
        "add_files_to_return": "Please add pictures or documents to support your complaint.",
        "accept_privacy_policy": "Please accept the privacy policy to continue.",
        "global_comment": "General comment",
        "privacy_policy": "I have read and accept the privacy policy*",
        "privacy_policy_description": "We will process and use your data carefully and in accordance with the applicable data protection laws. The personal data you provide will only be processed for the purpose of handling your inquiry and providing related support. Further details on the processing of your personal data by baum-bmwshop24.de (a brand of Baum Automobile GmbH & Co. KG), as well as detailed information on your data subject rights, can be found in our [privacy policy](https://www.baum-bmwshop24.de/datenschutz).",
        "success_message": {
            "title": "Request submitted successfully",
            "description": "Thank you for your request. We will process it as quickly as possible. **You will receive a confirmation of receipt by email within the next 30 minutes.** We will review your request after it has been received. In most cases, we will get back to you within 2 business days. Please wait for further instructions from us."
        },
        "close_message": "You can now close the window or return to the homepage.",
        "error_message": {
            "title": "An error has occurred",
            "description": "Unfortunately, an error occurred while submitting your request. Please try again later or contact our support for further assistance."
        },
        "form_submission_failed": "Submitting your complaint failed. Please review your entries and try again.",
        "additionalData": {
            "title": "Is this a spare part or an accessory?",
            "description": "To ensure that your claim can be processed as quickly as possible, we require this information so that the correct data can be recorded and forwarded to BMW. Spare parts and accessories are subject to different warranty conditions than vehicles, making this information essential for handling your claim."
        },
        "fill_additional_data": "Please complete the additional information to continue."
    },
    "orderCancel": {
        "title": "Cancel order",
        "description": "Please check the order and **confirm the cancellation at the bottom of the page.**",
        "form_submission_failed": "Canceling your order failed. Please try again later or contact our support for further assistance.",
        "success_message": {
            "title": "Order canceled successfully",
            "description": "Your refund will be processed automatically by our staff during regular business hours. You will receive a confirmation of receipt of the cancellation by email within the next 30 minutes."
        }
    },
    "returns": {
        "info": {
            "title": "Avoid returns for the sake of the environment",
            "description": "Every returned parcel has an environmental impact, which is why we do everything we can to minimize unnecessary shipping of items. Every avoided return saves at least 1.7 kg of CO2; avoiding seven returns per year corresponds to the compensation amount of one tree. Feel free to contact our support in advance, and we will gladly help you find the right item before your very first order.",
            "instructions": "Return guide: How it works",
            "more_info": "For more information, please refer to our [terms and conditions](https://www.baum-bmwshop24.de/agb/) and the [cancellation policy](https://www.baum-bmwshop24.de/widerruf/).",
            "shipping_info": "(*)For standard parcel returns, we charge EUR 7.90; for bulky parcel returns, we charge EUR 29.90. Return shipping costs will be deducted from the refund.",
            "steps": {
                "step_1": "Click the button “Register return now” and log in on the page using your customer number and purchase order number. You can find this information on the delivery note that should be inside the package and on the invoice you received by email.",
                "step_2": "In the next step, all items from the order will be listed. Please select the items, specify the quantity, and choose the reason for return. Click “Next” to proceed to the third step.",
                "step_3": "Here you have the opportunity to review the products you want to return and confirm them by clicking “Create return”.",
                "step_4": "Once the return has been created, please print the return document and include it with the package.",
                "step_5": "For parcel returns (within Germany), we provide a DHL shipping label. You can print this as well. Please note that we do **not** offer free return shipping(*).",
                "step_6": "Please pack the items carefully for return shipment and include the printed return document. Cut the DHL shipping label along the marking, attach it to the return package, and take it to the nearest DHL drop-off point.",
                "step_7": "Once we have received the package, we will create a cancellation invoice and refund you (minus return shipping costs) using the same payment method you used for the order. [br][br]**NOTE:** A refund of the purchase price is only possible for items without installation marks and/or damage and in the original packaging."
            }
        }
    }
}